import api from './api';
import { Order } from './order.api';
import { Booking } from './booking.api';

// ── Types ────────────────────────────────────────────────────────────────────

export interface AIPart {
  id: string;
  name: string;
  description?: string;
  price: number;
  qty: number;
}

export interface AIBookingInput {
  serviceType: string;
  scheduledDate: string;
  timeSlot?: string;
  technicianId?: string;
  technicianName?: string;
  serviceFee?: number;
  notes?: string;
}

export interface AICheckoutRequest {
  homeId: string;
  assetId: string;
  diagnosisIssue: string;
  diagnosisData: {
    issue: string;
    rootCauses: string[];
    diyResults?: Record<number, 'working' | 'not-working'>;
    diyAttempted?: boolean;
    parts?: string[];
  };
  shippingAddress?: string;
  // Parts order — omit if only booking
  parts?: AIPart[];
  subtotal?: number;
  taxAmount?: number;
  shippingCost?: number;
  totalAmount?: number;
  // Technician booking — omit if only ordering parts
  booking?: AIBookingInput;
  paymentIntentId?: string;
}

export interface AICheckoutResponse {
  orders: Order[];
  booking: Booking | null;
  orderId: string | null;
  bookingId: string | null;
}

// ── API Functions ────────────────────────────────────────────────────────────

/**
 * Single transactional checkout: creates order(s) + booking atomically.
 * Replaces the two separate createOrder / createBooking calls in AIDrawer.
 */
export const aiCheckout = async (data: AICheckoutRequest): Promise<AICheckoutResponse> => {
  return await api.post<AICheckoutResponse>('/v1/ai/checkout', data);
};
